import React from 'react'
import ContentForm from '../UI/ContentForm/ContentForm'
import Button from '../UI/Button/Button'
import Select from '../UI/Select/Select'
import Input from '../UI/Input/Input'
import Map from '../UI/Map/Map'
import Fade from 'react-reveal/Fade'
import './UnitPickupAddressForm.css'
import { checkValidity, IsIRNationalCodeValid, IsLegalNationalCodeValid, updateObject } from '../../shared/utility'
import FetchData from '../../shared/fetchData'
import { Grid } from '@mui/material'

const UnitPickupAddressForm = (props) => {

    const [lat, setLat] = React.useState(35.7575)
    const [lon, setLon] = React.useState(51.4099)
    const [zoom, setZoom] = React.useState(14)
    const [units, setUnits] = React.useState(props.units)
    const [cities, setCities] = React.useState(props.cities)
    const [unit, setUnit] = React.useState('')
    const [city, setCity] = React.useState('')
    const [edit, setEdit] = React.useState(props.edit)
    const [loading, setLoading] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [id, setId] = React.useState('')
    const [changeForm, setChangeForm] = React.useState(false)
    const [invalidSelect, setInvalidSelect] = React.useState(false)
    const [unitPickupAddress, setUnitPickupAddress] = React.useState({
        addressTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام آدرس'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        addressText: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                placeholder: 'آدرس'
            },
            validation: {
                required: true,
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        plateNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'پلاک'
            },
            validation: {
                required: true,
                justNumber: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        unitNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'واحد'
            },
            validation: {
                required: true,
                maxLength: 10,
                justNumber: true,
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        agentName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام نماینده'
            },
            validation: {
                required: true,
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        agentLastName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام خانوادگی نماینده'
            },
            validation: {
                required: true,
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        agentCellNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'تلفن همراه نماینده'
            },
            validation: {
                required: true,
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
    })

    React.useEffect(() => {
        if (props.edit) {
            const unt = unitPickupAddress
            unt.addressTitle.value = props.unitPickupAddress.addressTitle
            unt.addressText.value = props.unitPickupAddress.addressText
            unt.plateNumber.value = props.unitPickupAddress.plateNumber
            unt.unitNumber.value = props.unitPickupAddress.unitNumber
            unt.agentName.value = props.unitPickupAddress.agentName
            unt.agentLastName.value = props.unitPickupAddress.agentLastName
            unt.agentCellNumber.value = props.unitPickupAddress.agentCellNumber
            setLat(props.unitPickupAddress.lat)
            setLon(props.unitPickupAddress.lon)
            setUnitPickupAddress(unt)
            if (props.unitPickupAddress.unit != null) {
                const prnt = props.units.filter(u => u.id == props.unitPickupAddress.unit?.id)
                if (prnt != null && prnt.length != 0) {
                    setUnit({
                        value: prnt[0].id,
                        label: prnt[0].unitName
                    })
                }
                const cty = props.cities.filter(u => u.id == props.unitPickupAddress.city?.id)
                if (cty != null && cty.length != 0) {
                    setCity({
                        value: cty[0].id,
                        label: cty[0].description
                    })
                }
            }
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
            if (props.edit) {
                setId(props.unitPickupAddress.id)
            }
        }
    }, [])
    const changeMapHandler = (event) => {
        let lat = event.target.getCenter().lat
        let lng = event.target.getCenter().lng
        let zoom = event.target.getZoom()
        let ksk = unitPickupAddress
        setLat(lat)
        setLon(lng)
        setZoom(zoom)
        var addressRaw = JSON.stringify({ "lat": lat, "lon": lng, "version": "mtpx001" })
        var addressUrl = 'api/v1/geonames/getLatLonDesc'
        FetchData(addressRaw, addressUrl).then(response => response.json())
            .then(result => {
                ksk.addressText.value = result.text
                ksk.addressText.valid = true
                setUnitPickupAddress(ksk)
                if (rerender) {
                    setRerender(false)
                } else {
                    setRerender(true)
                }
            })
    }

    const changeLocation = (lat, lng) => {
        let ksk = unitPickupAddress
        var addressRaw = JSON.stringify({ "lat": lat, "lon": lng, "version": "mtpx001" })
        var addressUrl = 'api/v1/geonames/getLatLonDesc'
        setLat(lat)
        setLon(lng)
        FetchData(addressRaw, addressUrl).then(response => response.json())
            .then(result => {
                ksk.addressText.value = result.text
                ksk.addressText.valid = true
                setUnitPickupAddress(ksk)
                if (rerender) {
                    setRerender(false)
                } else {
                    setRerender(true)
                }
            })
    }


    const changeUnit = (selectedOption) => {
        setUnit(selectedOption)
        setInvalidSelect(false)
    }
    const changeCity = (selectedOption) => {
        setLat(selectedOption.lat)
        setLon(selectedOption.lon)
        setCity(selectedOption)
        setInvalidSelect(false)
    }

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(unitPickupAddress, {
            [controlName]: updateObject(unitPickupAddress[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, unitPickupAddress[controlName].validation),
                errorMessage: !checkValidity(event.target.value, unitPickupAddress[controlName].validation) ? 'مقدار وارد شده صحیح نیست' : unitPickupAddress[controlName].errorMessage
            })
        })
        setUnitPickupAddress(updatedControls)
    }

    const insertUpdateUnitPickupAddress = (event) => {
        let valid = true
        if (unit == null || unit == '' || city == null || city == '') {
            valid = false
            setInvalidSelect(true)
        }
        const unt = unitPickupAddress
        for (let key in unt) {
            if (key == 'postalcode' && unt[key].value.length < 10) {
                unt[key].valid = false
                unt[key].errorMessage = 'مقدار وارد شده صحیح نیست'
                valid = false
            }
            else if (key == 'nationalId') {
                const validNationalId = IsIRNationalCodeValid(unt[key].value) || IsLegalNationalCodeValid(unt[key].value);
                if (!validNationalId) {
                    unt[key].valid = false
                    unt[key].errorMessage = 'مقدار وارد شده صحیح نیست'
                    valid = false
                }
            }
            if (!checkValidity(unt[key].value, unt[key].validation)) {
                unt[key].valid = false
                valid = false
            }
        }
        if (!valid) {
            setUnitPickupAddress(unt)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        } else {
            if (!edit) {
                setLoading(true)
                const unt = unitPickupAddress
                var raw = JSON.stringify({
                    "unitPickupAddress": {
                        "unit": unit != null && unit != '' ? { id: unit.value } : '',
                        "city": city != null && city != '' ? { id: city.value } : '',
                        "addressTitle": unt.addressTitle.value,
                        "addressText": unt.addressText.value,
                        "plateNumber": unt.plateNumber.value,
                        "unitNumber": unt.unitNumber.value,
                        "lat": lat,
                        "lon": lon,
                        "agentName": unt.agentName.value,
                        "agentLastName": unt.agentLastName.value,
                        "agentCellNumber": unt.agentCellNumber.value,
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/unitPickupAddresses/insertUnitPickupAddress'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.toggleNewUnitPickupAddressForm(event, false)
                        }
                    })
                    .catch(error => setLoading(false))
            } else {
                setLoading(true)
                const unt = unitPickupAddress
                var raw = JSON.stringify({
                    "unitPickupAddress": {
                        "id": id,
                        "unit": unit != null && unit != '' ? { id: unit.value } : '',
                        "city": city != null && city != '' ? { id: city.value } : '',
                        "addressTitle": unt.addressTitle.value,
                        "addressText": unt.addressText.value,
                        "plateNumber": unt.plateNumber.value,
                        "unitNumber": unt.unitNumber.value,
                        "lat": lat,
                        "lon": lon,
                        "agentName": unt.agentName.value,
                        "agentLastName": unt.agentLastName.value,
                        "agentCellNumber": unt.agentCellNumber.value,
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/unitPickupAddresses/updateUnitPickupAddress'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.toggleNewUnitPickupAddressForm(event, false)
                        }
                    })
                    .catch(error => setLoading(false))
            }
        }
    }

    let unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName,
            })
        })
    }

    let cityList = []
    if (cities != null && cities.length != 0) {
        cities.map(z => {
            cityList.push({
                value: z.id,
                label: z.description,
                lat: z.lat,
                lon: z.lon,
            })
        })
    }

    const formElementsArray = [];
    for (let key in unitPickupAddress) {
        formElementsArray.push({
            id: key,
            config: unitPickupAddress[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        let col = '4 mt-2'
        if (formElement.config.elementConfig.type == 'textarea') {
            col = formElement.id == 'addressEn' ? "12 EN-input" : '12 mt-4'
        }
        if (formElement.id == 'addressText') {
            return (
                <div className="ksk-form-map">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <Map
                                cityId={'تهران'}
                                lat={lat}
                                lng={lon}
                                zoom={zoom}
                                latLngChangeHandler={changeMapHandler}
                                changeLocation={changeLocation}
                            />
                        </div>
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            placeholder={formElement.config.placeholder}
                            errorMessage={formElement.config.errorMessage}
                            search={true}
                            col={col}
                            changed={(event) => inputChangedHandler(event, formElement.id)} />
                    </div>
                </div>
            )
        } else {
            return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    search={true}
                    col={col}
                    changed={(event) => inputChangedHandler(event, formElement.id)} />
            )
        }
    })

    return (
        <Fade duration={200} left cascade>
            <div>
                <div className='row justify-content-center w-100 ml-0 mr-0'>
                    <Grid lg={9} md={9} sm={12} xs={12} >
                        <div className='unitPickupAddress-form-cntnr'>
                            <ContentForm headetText='حساب'>
                                <Select
                                    name="form-field-name"
                                    value={unit}
                                    placeholder="واحد ناظر"
                                    options={unitList}
                                    onChange={changeUnit}
                                    className={invalidSelect && unit == '' ? 'invalid-select' : ''}
                                    col="6 mt-2"
                                />
                                <Select
                                    name="form-field-name"
                                    value={city}
                                    placeholder="شهر"
                                    options={cityList}
                                    onChange={changeCity}
                                    className={invalidSelect && city == '' ? 'invalid-select' : ''}
                                    col="6 mt-2"
                                />
                                {form}
                                <div className='row w-100 justify-content-center mt-3'>
                                    <div className='col-6 text-center'>
                                        <Button btnType='Success' clicked={(event) => props.toggleNewUnitPickupAddressForm(event, false)}>برگشت</Button>
                                    </div>
                                    {!props.view ?
                                        <div className='col-6 text-center'>
                                            <Button btnType='Success' clicked={insertUpdateUnitPickupAddress}>ثبت</Button>
                                        </div>
                                        : ''}
                                </div>
                            </ContentForm>
                        </div>
                    </Grid>
                </div>
            </div>
        </Fade>
    )
}

export default UnitPickupAddressForm